const SYMBOL_LENGTH = 3

export const formatCurrency = (
  locale = 'pt-BR',
  value,
  currencyType = 'BRL',
  hideSymbol = false
) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: currencyType == 'percent' ? 'decimal' : 'currency',
    currency: 'BRL',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const formattedValue = (currencyType === 'percent' ? '% ' : '') + formatter.format(value)

  return formattedValue.slice(hideSymbol ? SYMBOL_LENGTH : 0)
}
